import { CARD_ACTIVATION_ELIGIBILITY_URL } from "../../const/endpoints";
export var CardActivationCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [CARD_ACTIVATION_ELIGIBILITY_URL, { accountId: accountId, accountIdType: accountIdType }];
};
//# sourceMappingURL=useCardActivation.types.js.map